/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import DynamicButton from '../Buttons/DynamicButton';
import { updateDocumentFirebase } from '../../Api/firebaseApi';

function AccessRoleUpdateButton({ roleData, setRoleData, index }) {
  const role = roleData?.[index];
  const [temp, setTemp] = useState('');

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const handlePopUp = (e) => {
    e.stopPropagation();
    setTemp(role?.title);
    onOpen();
  };

  const handleChange = (input) => {
    const regex = /^[A-Za-z\s-]+$/;
    if (!regex.test(input) && input !== '') return;
    setTemp(input.toLowerCase().replace(/\s+/g, '-'));
  }

  const handleUpdate = async () => {
    try {
      const others = JSON.parse(JSON.stringify(roleData));
      others.splice(index, 1);
      const similar = others.find((x) => x?.title === temp);
      if (similar) {
        toast({
          title: 'Nama role harus unik',
          description: 'Pilih nama role yang berbeda',
          status: 'error',
          duration: 3000,
        });
        return;
      } else {
        await updateDocumentFirebase('role_access', role?.id, { title: temp, source: 'wms' });
        setRoleData((prev) => {
          const newData = [...prev];
          newData[index].title = temp;

          return newData;
        });
        onClose();
        toast({
          title: 'Nama role berhasil diperbaharui',
          status: 'success',
          duration: 3000,
        });
      }
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return (
    <>
      <DynamicButton
        action="update"
        size="sm"
        variant="solid"
        disabled={role?.title === 'users' ? true : false}
        onClick={(e) => handlePopUp(e)}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Role</ModalHeader>
          <ModalBody>
            <FormControl>
              <FormLabel>Nama role</FormLabel>
              <Input variant="filled" value={temp} onChange={(e) => handleChange(e.target.value)} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Batal
            </Button>
            <Button colorScheme="yellow" onClick={() => handleUpdate()}>
              Update
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AccessRoleUpdateButton;
